import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.countryState.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.countryState.fields.name'),
  },
  {
    name: 'country',
    label: i18n('entities.countryState.fields.country'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.countryState.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.countryState.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
